import { Category, Filters } from "./search-base-model";

export interface AppState<Type> {
  searchState: SearchState<Type>
}

export interface SearchState<Type> {
  filters: Filters,
  currentItems: Type[],
  initialItems: Type[],
  categories: { [key: string] :  Category[] },
  selectedItem: any,
  showDetail: boolean,
}

export enum SearchStateActions {
  SET_LIST = 'SET_LIST',
  SET_CURRENT_LIST = 'SET_CURRENT_LIST',
  SET_FILTER = 'SET_FILTER',
  SET_CATEGORIES = 'SET_CATEGORIES',
  SET_SELECTED_ITEM = 'SET_SELECTED_ITEM',
  SHOW_DETAIL = 'SHOW_DETAIL',
  RESET_STATE = 'RESET_STATE',
  CLEAR_FILTER = 'CLEAR_FILTER',
}